<template>
    <div class="language">
        <span style="font-size: 14px;margin-right: 10px;">{{$STR('COMMON.main.lang', '切换语言')}}</span>
        <el-select v-model="currentLang" style="width: 120px" @change="switchLanguage">
            <el-option v-for="lanType in langOptions" :key="lanType.value" :label="lanType.label" :value="lanType.value"></el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    data() {
        return {
            currentLang: '',
            langOptions: [{ // 获取字典接口需要登录所以此处没有通过字典表获取
                value: 'CHNS',
                label: this.$STR('lang-type-chns', '简体中文')
            }, {
                value: 'CHNT',
                label: this.$STR('lang-type-chnt', '繁体中文')
            }, {
                value: 'ENG',
                label: this.$STR('lang-type-eng', '英文')
            }, {
                value: 'JPN',
                label: this.$STR('lang-type-jpn', '日文')
            }]
        };
    },
    props: {
        isLogin: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        visibleLang() {
            if (this.visibleLang) {
                this.dialogTitle = this.languageTitle;
                this.dialogVisible = this.visibleLang;
            }
        },
        dialogVisible() {
            if (!this.dialogVisible) {
                this.$emit('close');
            }
        }
    },
    mounted() {
        let lan = baseStore.getLanguage();
        for (let item of this.langOptions) {
            if (item.value === lan) {
                this.currentLang = item.label;
                this.switchLanguage(lan);
                break;
            }
        }
    },
    methods: {
        // 切换语言
        switchLanguage(val) {
            this.$switchLanguage(val, this.isLogin);
        }
    }
};
</script>
<style>
#language_dialog .el-dialog{
    width: 500px;
    height: 250px;
}
.language {
    display: flex;
    align-items: center;
    margin: 0 20px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/views/common/home/switchLang.vue